import React from 'react';
import cn from 'classnames';
import { string, number } from 'prop-types';

import styles from './styles.module.scss';

function ItemDescription({ className, description, orderId }) {
  return (
    <div key={orderId} className={cn('column full-width', styles.description, className)}>
      {description}
    </div>
  );
}

ItemDescription.propTypes = {
  description: string.isRequired,
  className: string,
  orderId: number
};

export default ItemDescription;
